import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import Layout from '../Layout';

const AboutPage = () => {
  const { t, language } = useLanguage();
  const { isDark } = useTheme();

  // Direct inline style for title color
  const titleStyle = {
    fontWeight: 700,
    color: isDark ? '#0ea5e9' : '#6b21a8' // sky-500 for dark, purple-800 for light
  };

  return (
    <Layout>
      <div className="space-y-6">
        <Helmet>
          <title>{language === 'zh' ? '關於 Beat Buddy | 互動式音樂節拍器' : 'About Beat Buddy | Interactive Music Metronome'}</title>
          <meta name="description" content={language === 'zh' ? "了解 Beat Buddy 節拍器的故事以及我們的使命：讓音樂練習變得更有趣且更有效率。" : "Learn about Beat Buddy metronome's story and our mission: making music practice more fun and effective."} />
          <meta name="keywords" content="Beat Buddy, metronome, music practice, music education, rhythm training" />
          <link rel="canonical" href="https://beatbuddy.app/about" />
        </Helmet>

        <div className="text-center max-w-xl mx-auto">
          <h2 className="text-3xl mb-2">
            <span style={titleStyle}>{t('aboutTitle')}</span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mx-auto">
            {t('aboutSubtitle')}
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('ourStory')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('ourStoryText1')}
            </p>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('ourStoryText2')}
            </p>
            <p className="mb-8 text-gray-700 dark:text-gray-300">
              {t('ourStoryText3')}
            </p>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('ourMission')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('ourMissionText')}
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-700 dark:text-gray-300">
              <li className="mb-2">{t('missionPoint1')}</li>
              <li className="mb-2">{t('missionPoint2')}</li>
              <li className="mb-2">{t('missionPoint3')}</li>
              <li className="mb-2">{t('missionPoint4')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('coreFeatures')}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="bg-purple-50 dark:bg-purple-900/30 p-4 rounded-xl">
                <h4 className="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">{t('interactiveCharacters')}</h4>
                <p className="text-gray-700 dark:text-gray-300">{t('interactiveCharactersDesc')}</p>
              </div>
              <div className="bg-blue-50 dark:bg-blue-900/30 p-4 rounded-xl">
                <h4 className="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">{t('achievementSystem')}</h4>
                <p className="text-gray-700 dark:text-gray-300">{t('achievementSystemDesc')}</p>
              </div>
              <div className="bg-green-50 dark:bg-green-900/30 p-4 rounded-xl">
                <h4 className="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">{t('customSettings')}</h4>
                <p className="text-gray-700 dark:text-gray-300">{t('customSettingsDesc')}</p>
              </div>
              <div className="bg-amber-50 dark:bg-amber-900/30 p-4 rounded-xl">
                <h4 className="font-semibold text-lg mb-2 text-gray-800 dark:text-gray-100">{t('practiceStats')}</h4>
                <p className="text-gray-700 dark:text-gray-300">{t('practiceStatsDesc')}</p>
              </div>
            </div>

            <h3 className="text-xl font-semibold mb-4 text-purple-600 dark:text-purple-400">{t('contactUs')}</h3>
            <p className="mb-4 text-gray-700 dark:text-gray-300">
              {t('contactUsText')}
            </p>
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-xl mb-4">
              <p className="mb-1 text-gray-700 dark:text-gray-300"><strong className="text-gray-800 dark:text-gray-200">{t('email')}：</strong> info@homy.hk</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;